import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputCheckBox from '../../../../../../../../components/NovoSistema/InputCheckBox';

export default function SaldoDeEstoqueFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputDate title="Data" id="Data" widthPercentage="20%" />
            <DoubleInput title="Produto" id="Produto" widthPercentage="60%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Tipo de Produto"
              id="TipoDeProduto"
              optionsArray={[
                '',
                'Mercadoria para revender',
                'Matéria Prima',
                'Embalagem',
                'Produto em processo',
                'Produto acabado',
                'Subproduto',
                'Produto intermediário',
                'Material de uso e consumo',
                'Ativo Imobilizado',
                'Outros insumos',
                'Outras',
              ]}
              widthPercentage="30%"
            />
            <DoubleInput title="Localização Inicial" id="LocalizacaoInicial" widthPercentage="30%" />
            <DoubleInput title="Localização Final" id="LocalizacaoFinal" widthPercentage="30%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Quebrado Por"
              id="QuebradoPor"
              optionsArray={['Produto', 'Grupo de Produto', 'Localização']}
              widthPercentage="30%"
            />
            <SelectAndOptions
              title="Tipo de Relatório"
              id="TipoDeRelatorio"
              optionsArray={['Analítico', 'Sintético']}
              widthPercentage="30%"
            />
            <InputCheckBox title="Exibir Apenas Produtos Com Saldo Zero" id="ExibirApenasProdutosComSaldoZero" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Divisão Gerencial"
              id="DivisaoGerencial"
              optionsArray={['', 'Grupo', 'Marca', 'Fabricante', 'Familia', 'SubTipo', 'Linha', 'Departamento']}
              widthPercentage="20%"
            />
            <DoubleInput title="Inicial" id="Inicial" widthPercentage="30%" disabled={true} />
            <DoubleInput title="Final" id="Final" widthPercentage="30%" disabled={true} />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
